import React from 'react';
import { Box, Typography } from '@mui/material';

// Shared shell for all Overview cards: consistent border, radius, padding and header
const OverviewCard = ({ title, subtitle, action, children, sx, contentSx }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      minWidth: 0,
      backgroundColor: "var(--c-surface)",
      border: "1px solid var(--c-border)",
      borderRadius: "16px",
      overflow: "hidden",
      transition: "box-shadow 150ms ease",
      "&:hover": { boxShadow: "0 4px 16px rgba(15, 23, 42, 0.06)" },
      ...sx,
    }}
  >
    {(title || action) && (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          px: 2.5,
          pt: 2,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: "var(--c-text)", lineHeight: 1.3 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography sx={{ fontSize: 13, color: "var(--c-text-muted)", lineHeight: 1.4 }} noWrap>
              {subtitle}
            </Typography>
          )}
        </Box>
        {action}
      </Box>
    )}
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, p: 2.5, pt: 1.5, ...contentSx }}>
      {children}
    </Box>
  </Box>
);

export default OverviewCard;
